import React, {useEffect, useRef, useState} from "react";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { useHistory, Link } from "react-router-dom";
import {FaFacebookF} from "react-icons/fa6";
import {FaInstagram, FaYoutube, FaTiktok, FaLinkedinIn, FaBars, FaTimes} from "react-icons/fa";
import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
} from "react-share";
import "./header.scss";
import { Tag } from "rsuite";
import { backendService } from "../../services/backend.service";
import {
    isPushNotificationSupported,
    sendNotification,
    initializePushNotifications,
} from "./header.notification";
import { InputGroupText, Input, InputGroup, Alert } from "reactstrap";
import {
    FaBellSlash,
    FaCopy,
    FaFacebook,
    FaLinkedin,
    FaSignOutAlt,
    FaWhatsapp,
} from "react-icons/fa";
import { Dropdown } from "rsuite";
import { FaXTwitter } from "react-icons/fa6";
import { ImgCache } from "../CustonHooks/imgCache";
import { Tooltip } from "antd";
import "rsuite/dist/styles/rsuite-default.css";
import JSONSocialMedia from "../../assets/jsons/listSocialMedia.json";
import {ModalLogin} from "../modalLogin/modalLogin";
import useWindowViewport from "../../hooks/useWindowViewport";
import {Button as ButtonAntd} from "antd";
import useOutsideClick from "../../hooks/useOutsideClick";
import {LogoutUser} from "../../utils/AuthFunctions";
import LogoPrideCom from "../../assets/imgs/R_C.png";
import {useValidTokenFromStorage} from "../../hooks/authHook";
import {useSelector} from "react-redux";

export const Header = ({ windowDimensions, MyFun, activeBtn, userProfile}) => {
    const history = useHistory();
    const [notificationInfo, setNotificationInfo] = useState({
        notificationInfoData: [],
    });
    const [companyLogo, setCompanyLogo] = useState(LogoPrideCom);
    const [connection, setConnection] = useState(null);
    const [listSocialMedia, setListSocialMedia] = useState([]);
    const iconMap = {
        FaFacebookF: FaFacebookF,
        FaInstagram: FaInstagram,
        FaXTwitter: FaXTwitter,
        FaYoutube: FaYoutube,
        FaTiktok: FaTiktok,
        FaLinkedinIn: FaLinkedinIn,
    };
    const [menuItems, setMenuItems] = useState([]);
    const [visible, setVisible] = useState(false);
    const [widgets, setWidgets] = useState({
        surveyWidget: {},
        messageWidget: {},
        rewardWidget: {},
        courseWidget: {},
        providerWidget: [{ id: 0, logoCrls: "" }],
    });
    const [dropdownOpen, setDropdownOpen] = useState(false);
    let urls = window.location.href;
    const { windowWidth } = useWindowViewport();
    const [isMobile, setIsMobile] = useState(false);
    const menuRef = useRef(null);
    const validateToken = useValidTokenFromStorage();

    useOutsideClick({
        ref: menuRef,
        handler: () => setVisibleMenu(false),
    });

    const toggle = () => setDropdownOpen((prevState) => !prevState);

    const miPerfil = () => history.push("profile");

    useEffect(() => {
        if (performance.navigation.type !== 1) {
            let isFirstTime = localStorage["isFirstTime"];
            if (isFirstTime === undefined) {
                localStorage["isFirstTime"] = true;
                if (isPushNotificationSupported()) {
                    initializePushNotifications().then(function (dataConsent) {
                        if (dataConsent === "granted") GetnotificationApi(true, false);
                    });
                }
            }
        }
        GetnotificationApi(false, true);
        setListSocialMedia(JSONSocialMedia)
    }, []);

    const GetnotificationApi = (ShowPush, ShowNotif) => {
        backendService.GetNotificationData().then((result) => {
            if (result) {
                if (ShowPush) sendNotification(result);
                if (ShowNotif) setNotificationInfo({ notificationInfoData: result });
            }
        });
    };

    const onDismiss = () => setVisible(!visible);
    const showAlert = () => setVisible(!visible);

    const [visibleMenu, setVisibleMenu] = useState(false);
    const handleMenu = () => setVisibleMenu(!visibleMenu);

    const ShareDropdown = ({ url, visible, onDismiss, showAlert }) => (
        <Tooltip placement="left" title="Compartir página">
            <Dropdown
                placement="bottomEnd"
                trigger={["click"]}
                title={<i className="icon-share"></i>}
                className="button-circle light share"
            >
                <div className="sharing-content">
                    <p>Comparte esta página</p>
                    <div className="icons">
                        <FacebookShareButton url={url} className="facebook">
                            <FaFacebook size={24} />
                        </FacebookShareButton>
                        <TwitterShareButton url={url} className="twitter">
                            <FaXTwitter size={24} />
                        </TwitterShareButton>
                        <WhatsappShareButton url={url} className="whatsapp">
                            <FaWhatsapp size={24} />
                        </WhatsappShareButton>
                        <LinkedinShareButton url={url} className="linkedin">
                            <FaLinkedin size={24} />
                        </LinkedinShareButton>
                    </div>
                    <Alert color="success" isOpen={visible} toggle={onDismiss}>
                        ¡Link copiado!
                    </Alert>
                    <p>O copia el link</p>
                    <div className="copy-paste">
                        <InputGroup>
                            <Input type="text" readOnly value={url} />
                            <InputGroupText>
                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(url);
                                        showAlert();
                                    }}
                                >
                                    <FaCopy />
                                </button>
                            </InputGroupText>
                        </InputGroup>
                    </div>
                </div>
            </Dropdown>
        </Tooltip>
    );

    const NotificationsDropdown = ({ notificationInfo, toggle }) => {
        const notifications = notificationInfo?.notificationInfoData || [];

        return (
            <Tooltip placement="left" title="Notificaciones">
                <Dropdown
                    className="button-circle light notifications"
                    trigger={["click"]}
                    placement="bottomEnd"
                    title={
                        <>
                            <i className="icon-notifications"></i>
                            <span className="quantity">{notifications.length}</span>
                        </>
                    }
                >
                    <div className="notifications-body">
                        <div className="notifications-title">Notificaciones</div>
                        <ul className={`notifications-content ${notifications.length === 0 ? "empty" : ""}`}>
                            {notifications.length > 0 ? (
                                notifications.map((item, index) => (
                                    <li className="notifications-content-item" key={index}>
                                        <a href={item.link} onClick={() => toggle(item)}>
                                            <span>{item.companyEventTypeNotificationMessage}</span>
                                            <p>{item.message}</p>
                                        </a>
                                    </li>
                                ))
                            ) : (
                                <li className="notifications-content-empty">
                                    <FaBellSlash />
                                    <span>No hay nuevas notificaciones</span>
                                </li>
                            )}
                        </ul>
                    </div>
                </Dropdown>
            </Tooltip>
        );
    };

    const avatarClass = userProfile?.genderIdentityFlag
        ? `avatar-box rotating ${userProfile.genderIdentityFlag}`
        : "avatar-box rotating";

    const hasNotifications = notificationInfo?.notificationInfoData?.length > 0;

    const titleContent = (
        <>
            <div className="avatar">
                <div className={avatarClass}></div>
                <img src={userProfile?.urlProfileImage} alt="PMX" />
            </div>
            <div className="user-info">
                <p className="m-0 text fnt_bold">{userProfile?.firstName !== " " ? userProfile?.firstName : "@"+userProfile?.email.split('@')[0]}</p>
                <p className="m-0">{userProfile?.reward} puntos</p>
            </div>
            {windowDimensions <= 575 && hasNotifications && <span className="dot_notif"></span>}
        </>
    );

    useEffect(() => {
        if(windowWidth < 992)
            setIsMobile(true);
        else
            setIsMobile(false);
    }, [windowWidth]);

    useEffect(() => {
        if (connection) {
            connection
                .start()
                .then(() => {
                    connection.on("beNotified", (notification) => {
                        const listaEventos = [];
                        listaEventos.push(notification);
                        sendNotification(listaEventos);
                        GetnotificationApi(false, true);
                    });
                })
                .catch((error) => console.log(error));
        }
    }, [connection]);

    useEffect(() => {
        backendService.widgets().then((data) => {
            if (data.surveyWidget != null) {
                let date = new Date();
                date.setDate(date.getDate() + data.surveyWidget.expirationDays);
                data.surveyWidget.expirationDate = date;
            }
            setWidgets(data);
        });

        const connection = new HubConnectionBuilder()
            .withUrl(`${process.env.REACT_APP_HUB_URL}/notification`, {
                headers: { NoBlocking: true },
            })
            .withAutomaticReconnect()
            .build();

        setConnection(connection);
        setMenuItems(
            [
                {
                    title: "Entretenimiento",
                    items: [
                        {
                            label: "Cartelera Pride",
                            href: "/course-view",
                            badge: widgets.courseWidget?.quantity,
                        },
                        { label: "Galería", href: "/blog-company/gallery" },
                        { label: "Pride Talks", href: "/audience" },
                        { label: "Pride Music", href: "/pride-music" },
                    ],
                },
                {
                    title: "Información",
                    items: [
                        { label: "Mundo Pride", href: "/blog-company" },
                        { label: "Orgullo Pride", href: "/stories-pride" },
                    ],
                },
                {
                    title: "Comunidad",
                    items: [
                        { label: "Bolsa de trabajo", href: "/job-bank" },
                        { label: "Economía incluyente", href: "/directory" },
                        { label: "Grupos de interés", href: "/interest-group" },
                    ],
                },
                {
                    title: "Beneficios",
                    items: [
                        { label: "Beneficios Pride", href: "/discount" },
                        ...(validateToken ? [{ label: "Rewards", href: "/rewards" }] : []),
                    ],
                },
            ]
        );
    }, []);

    return (
        <header className="header">
            <div className="header__top">
                <div className="container-page">
                   <div className={"navigation__container"}>
                       <div className="header__social">
                           {
                               (windowWidth > 380) && (<span>Síguenos en </span>)
                           }
                           {
                               listSocialMedia?.map((item,i) => {
                                   const IconComponent = iconMap[item.icon];
                                   return (
                                       <a
                                           target="_blank"
                                           rel="noopener noreferrer"
                                           className={item.name}
                                           href={item.url}
                                           key={i}
                                       >
                                           {IconComponent ? <IconComponent /> : null}
                                       </a>
                                   )
                               })
                           }
                       </div>
                       {(userProfile?.aspNetRoleName === "Recursos Humanos" && validateToken) && (
                           <>
                               <div className="header__user-admin">
                                   <Link to="/admin">Soy administrador</Link>
                               </div>
                           </>
                       )}
                   </div>
                </div>
            </div>
            <div className="navigation">
                <div className="container-page">
                   <div className={"navigation__container"}>
                       <div className="navigation__logo">
                           {
                               (isMobile) && (
                                   <ButtonAntd type={"default"} onClick={handleMenu} className={(visibleMenu) ? "active" : ""}>
                                       {(visibleMenu) ? <FaTimes /> : <FaBars />}
                                   </ButtonAntd>
                               )
                           }
                            <a href={userProfile?.aspNetRoleName === "Operaciones" ? "/homeOps/1" : "/home"}>
                               <ImgCache src={companyLogo} alt={"Logo Kuimby"} />
                           </a>
                       </div>
                       <nav className={`navigation__nav ${visibleMenu ? "active" : ""}`} ref={menuRef}>
                           {menuItems?.map((menu, idx) => (
                               <Dropdown noCaret title={menu.title} key={idx}>
                                   {menu.items.map((item, i) => (
                                       <Dropdown.Item as={Link} href={item.href} key={i}>
                                           {item.label}
                                           {item.badge && (
                                               <span className="veiw_badge">{item.badge}</span>
                                           )}
                                       </Dropdown.Item>
                                   ))}
                               </Dropdown>
                           ))}
                       </nav>
                       <div className="navigation__user">
                           {
                               (validateToken) ? (
                                       <>
                                           {
                                               (windowWidth > 768) && (
                                                   <>
                                                       <ShareDropdown url={urls} visible={visible} onDismiss={onDismiss} showAlert={showAlert} />
                                                       <NotificationsDropdown notificationInfo={notificationInfo} toggle={toggle} />
                                                   </>
                                               )
                                           }
                                           <Dropdown
                                               noCaret
                                               className="button-user"
                                               trigger={["click"]}
                                               placement="bottomEnd"
                                               title={titleContent}
                                           >
                                               <Dropdown.Item onClick={miPerfil} href="/profile">
                                                   <i className="icon-user"></i>
                                                   <p>Mi Perfil</p>
                                               </Dropdown.Item>

                                               {windowDimensions <= 575 && (
                                                   <Dropdown
                                                       className="dropdown-notifications notif__mobile"
                                                       placement="bottomEnd"
                                                       noCaret
                                                       title={
                                                           <>
                                                               <i className="icon-notifications"></i>
                                                               <p>
                                                                   Notificaciones
                                                                   <Tag size="sm" color="orange">
                                                                       {notificationInfo?.notificationInfoData?.length || 0}
                                                                   </Tag>
                                                               </p>
                                                           </>
                                                       }
                                                   >
                                                       <Dropdown.Menu
                                                           title={
                                                               <div className="notifications-body">
                                                                   <div className="notifications-title">Notificaciones</div>
                                                                   <ul
                                                                       className={`notifications-content ${
                                                                           hasNotifications ? "" : "empty"
                                                                       }`}
                                                                   >
                                                                       {hasNotifications ? (
                                                                           notificationInfo.notificationInfoData.map((item, index) => (
                                                                               <li className="notifications-content-item" key={index}>
                                                                                   <a href={item.link} onClick={() => toggle(item)}>
                                                                                       <span>{item.companyEventTypeNotificationMessage}</span>
                                                                                       <p>{item.message}</p>
                                                                                   </a>
                                                                               </li>
                                                                           ))
                                                                       ) : (
                                                                           <li className="notifications-content-empty">
                                                                               <FaBellSlash />
                                                                               <span>No hay nuevas notificaciones</span>
                                                                           </li>
                                                                       )}
                                                                   </ul>
                                                               </div>
                                                           }
                                                       />
                                                   </Dropdown>
                                               )}

                                               <Dropdown.Item href="/logout" onClick={LogoutUser}>
                                                   <i>
                                                       <FaSignOutAlt />
                                                   </i>
                                                   <p>Cerrar sesión</p>
                                               </Dropdown.Item>
                                           </Dropdown>
                                       </>
                                   ) :
                                   (
                                       <>
                                           <ModalLogin />
                                       </>
                                   )
                           }
                       </div>
                   </div>
                </div>
                <script src="/service-worker.js" />
            </div>
        </header>
    );
}
